module.exports = __webpack_public_path__ + "c_static/img/2-4淘宝-收藏夹.c315741.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/2-4淘宝-收藏夹.jpg
// module id = kMlI
// module chunks = 33